import { render } from "./MovimentoFinanceiroAnexo.vue?vue&type=template&id=f9813738&ts=true"
import script from "./MovimentoFinanceiroAnexo.vue?vue&type=script&lang=ts"
export * from "./MovimentoFinanceiroAnexo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__